/** Points deducted at the deadline for each transfer beyond the free allowance. */
export const POINTS_PER_TRANSFER_HIT = 4;

/**
 * The points-hit consequence of committing a set of transfers. Single source of
 * truth for the hit warning, so the pick page and the AI transfer tabs cannot
 * disagree about what a member is about to pay.
 */
export type TransferHit = {
  /** Free transfers available this gameweek (0 when unlimited or unknown). */
  free: number;
  /** Total transfers made this gameweek once these ones are committed. */
  made: number;
  /** Points deducted at the deadline (0 when within the free allowance). */
  points: number;
  /** Whether committing would exceed the free allowance and incur a hit. */
  exceedsFree: boolean;
};

/**
 * Mirrors scoreline-app's useTransferMode. A null allowance means unlimited
 * (GW1, wildcard or free hit active), where no transfer is ever paid for.
 */
export const deriveTransferHit = (
  freeTransfers: number | null | undefined,
  transfersMade: number
): TransferHit => {
  const hasFiniteFreeTransfers = typeof freeTransfers === 'number';
  const free = hasFiniteFreeTransfers ? freeTransfers : 0;
  const paidTransfers = hasFiniteFreeTransfers
    ? Math.max(0, transfersMade - free)
    : 0;

  return {
    free,
    made: transfersMade,
    points: paidTransfers * POINTS_PER_TRANSFER_HIT,
    exceedsFree: paidTransfers > 0
  };
};
